import { render, staticRenderFns } from "./receipt-detail.vue?vue&type=template&id=5369de90&scoped=true"
import script from "./receipt-detail.vue?vue&type=script&lang=js"
export * from "./receipt-detail.vue?vue&type=script&lang=js"
import style0 from "./receipt-detail.vue?vue&type=style&index=0&id=5369de90&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5369de90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5369de90')) {
      api.createRecord('5369de90', component.options)
    } else {
      api.reload('5369de90', component.options)
    }
    module.hot.accept("./receipt-detail.vue?vue&type=template&id=5369de90&scoped=true", function () {
      api.rerender('5369de90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/compliancecso/taxPaymentReceipt/components/receipt-detail.vue"
export default component.exports